import React, { useEffect, useMemo, useState } from "react";
import { Card } from "antd";
import { useAppDispatch } from "Store/hooks";
import { setActiveKey } from "Layout/redux/slice";
import { setLoadingState } from "Components/Basic/full_page_loader/redux/slice";
import { setErrorState } from "Components/Basic/ErrorBoundary/redux/slice";
import {
  getAllPaddleProducts,
  getFeatureGroups,
  getProductEditions,
} from "./redux/thunks";
import {
  selectPaddleProductList,
  selectIsPaddleProductLoading,
} from "./redux/selectors";
import { useAppSelector } from "Store/hooks";
import PaddleProductTable from "./table/table.index";
import PaddleProductToolbar from "./toolbar/toolbar.index";
import { IPaddleProduct } from "./redux/types";
import "./paddleProducts.index.css";

const PaddleProducts = () => {
  const dispatch = useAppDispatch();
  const productList = useAppSelector(selectPaddleProductList);
  const isLoading = useAppSelector(selectIsPaddleProductLoading);
  const [searchText, setSearchText] = useState("");

  const filteredData = useMemo(() => {
    const safeProductList = productList || [];
    if (!Array.isArray(safeProductList)) {
      return [];
    }
    if (!searchText || searchText === "") return safeProductList;

    const text = searchText.toLowerCase();
    return safeProductList.filter((product: IPaddleProduct) => {
      if (!product) return false;
      return (
        product.name?.toLowerCase().includes(text) ||
        product.description?.toLowerCase().includes(text) ||
        product.productEdition?.toLowerCase().includes(text) ||
        product.productId?.toLowerCase().includes(text)
      );
    });
  }, [productList, searchText]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(setLoadingState(true));
        dispatch(setActiveKey(["payment-products"]));
        await dispatch(getAllPaddleProducts()).unwrap();
        await dispatch(getFeatureGroups()).unwrap();
        await dispatch(getProductEditions()).unwrap();
      } catch (err: any) {
        dispatch(
          setErrorState({
            message: "Error",
            description: err.message || "Failed to load Paddle products",
            placement: "topRight",
            type: "error",
          })
        );
      } finally {
        dispatch(setLoadingState(false));
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <div className="paddle-products-container">
      <Card className="paddle-products-scrollable-wrapper">
        <PaddleProductToolbar onSearch={setSearchText} />
        <div className="table-scroll-container">
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <div>Loading Paddle products...</div>
            </div>
          ) : (
            <PaddleProductTable data={filteredData} />
          )}
        </div>
      </Card>
    </div>
  );
};

export default PaddleProducts;

